var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultHeadshot = function SvgDefaultHeadshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_35039)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F0F0F0",
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.606 34.182c0-10.845 8.683-19.637 19.394-19.637s19.394 8.792 19.394 19.637S50.711 53.818 40 53.818s-19.394-8.791-19.394-19.636"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.182,
    height: 40,
    x: 10.909,
    y: 58.182,
    fill: "#fff",
    rx: 18.333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_35039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#fff",
    rx: 40
  })))));
};
export default SvgDefaultHeadshot;